"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleInstanceNotFoundError = void 0;
exports.isModuleInstanceNotFoundError = isModuleInstanceNotFoundError;
class ModuleInstanceNotFoundError extends Error {
    constructor(refOrName, hint) {
        super(`project_module not found: ${refOrName}`);
        this.name = this.constructor.name;
        this.refOrName = refOrName;
        this.hint = hint;
    }
}
exports.ModuleInstanceNotFoundError = ModuleInstanceNotFoundError;
function isModuleInstanceNotFoundError(error) {
    return error instanceof ModuleInstanceNotFoundError;
}
//# sourceMappingURL=project-model.errors.js.map